I18n.translations || (I18n.translations = {});
I18n.translations["de"] = I18n.extend((I18n.translations["de"] || {}), {
  "date": {
    "abbr_day_names": [
      "So",
      "Mo",
      "Di",
      "Mi",
      "Do",
      "Fr",
      "Sa"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mär",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dez"
    ],
    "day_names": [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag"
    ],
    "formats": {
      "compact": "%d.%m.%Y",
      "default": "%d. %B %Y",
      "default2": "%d.%m.%Y",
      "long": "%e. %B %Y",
      "only_day": "%e",
      "short": "%e. %b",
      "short_date_with_week_day": "%a %d.%m.%Y"
    },
    "month_names": [
      null,
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ],
    "order": [
      "day",
      "month",
      "year"
    ]
  },
  "fundraising_events": {
    "admin_boxes": {
      "show": {
        "do_list_picture": {
          "link_text": "Lade ein Bild hoch",
          "list_item_html": ", das deine Aktion beschreibt und deine Spender motiviert."
        },
        "do_list_share": {
          "link_text": "Verbreite die Aktionsseite",
          "list_item_html": " per E-Mail, Facebook, WhatsApp, …"
        },
        "do_list_thank_you_message": {
          "link_text": "Erstelle eine persönliche Dankesbotschaft",
          "list_item_html": " für deine Spender*innen."
        },
        "forwarding_notice": "Übrigens: Du kannst den Projekten %{amount} zuordnen. ♥",
        "headline": "Du möchtest deine Spendenaktion bearbeiten oder Neuigkeiten schreiben?",
        "manage_area_link": "Administrationsbereich",
        "recent_registration_notice_html": "<p>Glückwunsch, deine Spendenaktion ist nun online!</p>\n<p>Was jetzt zu tun ist:</p>",
        "streamer_blogpost": {
          "link_text": "Dos and Don’ts lesen:",
          "link_url": "https://www.betterplace.org/c/hilfe/charitystreams-dos-and-donts",
          "list_item_html": " – was gibt es zu beachten, und wie wird dein Charitystream ein Erfolg …",
          "nickname_link_text": "Nicknamen",
          "nickname_text_1": "Trage deinen",
          "nickname_text_2": "als öffentlichen Namen ein.",
          "overlay_link_text": "Konfiguriere die Overlays",
          "overlay_text": "für deinen Charitystream."
        }
      }
    },
    "forwardings": {
      "index": {
        "headline": "Spendenübersicht",
        "introduction_html": "In dieser Übersicht kannst du nachvollziehen, welche Projekte wie viele Spenden erhalten haben. \n",
        "not_forwarded_label": "Diese Spenden werden von %{manager_name} noch zugeordnet",
        "sum_of_donations_label": "Summe aller Spenden",
        "zero_prefix_label": "bisher"
      }
    },
    "news": {
      "index": {
        "headline": "Alle Neuigkeiten (%{total_entries})"
      },
      "recent": {
        "headline": "Neuigkeiten"
      },
      "show": {
        "admin_box": {
          "tutorial_send_as_newsletter": "NEU! Diese Neuigkeit als Newsletter versenden …"
        }
      }
    },
    "opinions": {
      "index": {
        "call_for_first_donation": "Ha! Sei die erste und zieh alle anderen mit! :)",
        "carousel_controls_details": "%{current_page} von %{total_pages}",
        "donated_label": "hat gespendet",
        "headline": {
          "one": "Spende (1)",
          "other": "Spenden (%{count})",
          "zero": "Spenden"
        },
        "no_donations_notice": "Es gibt noch keine Spenden"
      },
      "opinion": {
        "anonymous": "Anonym",
        "headline_html": "<strong>%{author}</strong> hat %{time_ago} gespendet",
        "project_manager": "(verantwortlich)"
      }
    },
    "projects": {
      "index": {
        "headline": {
          "one": "Du unterstützt dieses Projekt:",
          "other": "Du unterstützt diese %{count} Projekte:"
        },
        "read_more_link": "Alle anzeigen"
      }
    },
    "show": {
      "basic_information": {
        "not_tax_deductible_notice": "ohne Spendenbescheinigung",
        "subheadline": "Eine Spendenaktion von %{name}"
      },
      "description": {
        "creation_information_html": "hat diese Spendenaktion am %{created_at} veröffentlicht.",
        "headline": "Worum es geht",
        "hint_html": "Die Projekte können durch %{name} noch angepasst werden.",
        "new_message_link": "Nachricht schreiben"
      },
      "landingpage_teaser_elements": {
        "birthday_fundraising_events_html": "Du möchtest an deinem eigenen Geburtstag auch um Spenden statt Geschenke bitten? Dann <a href=\"%{landingpage_url}\">mach deinen Geburtstag zu einer Spendenaktion</a>!",
        "marathon_fundraising_events_html": "Du möchtest ebenfalls für einen guten Zweck laufen oder Rad fahren? Dann <a href=\"%{landingpage_url}\">mach einen Spendenlauf und lege eine Spendenaktion auf betterplace.org an</a>."
      },
      "numbers": {
        "donated_amount_label": "gesammelt",
        "donation_count_label": {
          "one": "Spende",
          "other": "Spenden"
        },
        "goto_description_link": "Worum es geht?",
        "share_link": "Spendenaktion teilen",
        "target_amount_label": "unser Ziel"
      },
      "page_title_part": "Mach mit bei meiner Spendenaktion",
      "sharing": {
        "copy_alert": {
          "headline": "Link kopiert!",
          "text": " Du kannst den Link in deiner Bio oder Story bei Instagram einfügen."
        },
        "default_teaser": "Bitte unterstütze dieses Projekt auf betterplace",
        "email_share_label": "Empfehle diese Spendenaktion via E-Mail!",
        "email_teaser": "Ich habe auf betterplace.org eine tolle Aktion gefunden",
        "facebook_share_label": "Teile diese Spendenaktion auf Facebook!",
        "headline": "Gefällt dir die Spendenaktion? Dann hilf mit!",
        "instagram_share_label": "Kopiere den Link zu dieser Spendenaktion für Instagram!",
        "link_share_label": "Kopiere den Link zu dieser Spendenaktion!",
        "messenger_share_label": "Teile diese Spendenaktion auf Facebook Messenger!",
        "share_call_to_action": "Und erzähl deinen Freunden davon.",
        "twitter_share_label": "Tweete diese Spendenaktion!",
        "twitter_share_text": "Unterstütze jetzt die Spendenaktion %{name}",
        "whatsapp_share_label": "Teile diese Spendenaktion auf Whatsapp!"
      }
    }
  },
  "misc": {
    "donate_button": "Jetzt spenden!",
    "state_labels": {
      "activated": "Aktiv",
      "active": "Aktiv",
      "awarded": "Gefördert",
      "blocked": "Deaktiviert",
      "canceled": "Abgebrochen",
      "closed": "Beendet",
      "completed": "Finanziert",
      "confirmed": "Bestätigt",
      "created": "Erzeugt",
      "deleted": "Gelöscht",
      "finished": "Erledigt",
      "inactive": "Inaktiv",
      "new": "Neu",
      "paid_out": "Überwiesen",
      "pending": "Wartet",
      "preparing": "In Vorbereitung",
      "produced": "In Bearbeitung",
      "proposed": "In Freigabe",
      "rejected": "Abgelehnt",
      "requested": "Angefordert",
      "revoked": "Zurückgebucht",
      "started": "Gestartet",
      "submitted": "Abgeschickt"
    }
  },
  "news": {
    "news_helper": {
      "blog_details_html": "%{author} schrieb am %{created_at}"
    },
    "no_results": {
      "call_to_action_html": "<a href='%{message_url}'>Frag doch %{manager_name}</a>, ob es schon etwas zu berichten gibt.",
      "notice": "Es gibt noch keine Neuigkeiten."
    }
  }
});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "formats": {
      "compact": "%d-%m-%Y",
      "default": "%d %B %Y",
      "default2": "%d-%m-%Y",
      "long": "%B %d, %Y",
      "only_day": "%e",
      "short": "%b %d",
      "short_date_with_week_day": "%a %d %b %Y"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "fundraising_events": {
    "admin_boxes": {
      "show": {
        "do_list_picture": {
          "link_text": "Upload a picture",
          "list_item_html": " that shows what your fundraising event is all about."
        },
        "do_list_share": {
          "link_text": "Share your fundraising event",
          "list_item_html": " via e-mail, Facebook, WhatsApp, …"
        },
        "do_list_thank_you_message": {
          "link_text": "Create a personal thank you message",
          "list_item_html": " for your supporter."
        },
        "forwarding_notice": "By the way, you have %{amount} to forward to your chosen projects. ♥",
        "headline": "You’d like to update your fundraising event or add some news? ",
        "manage_area_link": "Admin area",
        "recent_registration_notice_html": "<p>Congratulations, your fundraising event is now online!</p>\n<p>Here’s what you still have to do:</p>",
        "streamer_blogpost": {
          "link_text": "Read our dos and don’ts of charity streaming",
          "link_url": "https://www.betterplace.org/c/hilfe/charitystreams-dos-and-donts",
          "list_item_html": "– read about pitfalls and how to make your charity stream a success ...",
          "nickname_link_text": "nickname",
          "nickname_text_1": "Enter your",
          "nickname_text_2": "as public name.",
          "overlay_link_text": "Configure the overlays",
          "overlay_text": "for your charity stream."
        }
      }
    },
    "forwardings": {
      "index": {
        "headline": "Summary of donations\n",
        "introduction_html": "In this summary you can see how much has been forwarded to each project. ",
        "not_forwarded_label": "Donations still to be forwarded by %{manager_name}",
        "sum_of_donations_label": "Total sum of all donations",
        "zero_prefix_label": "so far"
      }
    },
    "news": {
      "index": {
        "headline": "All news (%{total_entries})"
      },
      "recent": {
        "headline": "News"
      },
      "show": {
        "admin_box": {
          "tutorial_send_as_newsletter": "NEW! Send this news entry as a newsletter…"
        }
      }
    },
    "opinions": {
      "index": {
        "call_for_first_donation": "Hey! Why not be the first and get everyone else to join in! :)",
        "carousel_controls_details": "%{current_page} of %{total_pages}",
        "donated_label": "donated",
        "headline": {
          "one": "Donation (1)",
          "other": "Donations (%{count})",
          "zero": "Donations"
        },
        "no_donations_notice": "No donations received so far."
      },
      "opinion": {
        "anonymous": "An anonymous user ",
        "headline_html": "<strong>%{author}</strong> donated %{time_ago}",
        "project_manager": "(Project Manager)"
      }
    },
    "projects": {
      "index": {
        "headline": {
          "one": "You’re supporting this project:",
          "other": "You’re supporting these %{count} projects:"
        },
        "read_more_link": "Show all"
      }
    },
    "show": {
      "basic_information": {
        "not_tax_deductible_notice": "without donation receipt",
        "subheadline": "%{name}’s fundraising event"
      },
      "description": {
        "creation_information_html": "announced this fundraising event on %{created_at}.",
        "headline": "What's it about?",
        "hint_html": "The projects can still be changed by %{name}.",
        "new_message_link": "Write a message"
      },
      "landingpage_teaser_elements": {
        "birthday_fundraising_events_html": "You also want to ask for donations instead of gifts for your birthday? Then <a href=\"%{landingpage_url}\">turn your birthday into a fundraising event</a>.",
        "marathon_fundraising_events_html": "<a href=\"%{landingpage_url}\">You also want to do a charity run? Then create a fundraising event on betterplace.org</a>. It works for any kind of sport!"
      },
      "numbers": {
        "donated_amount_label": "Collected",
        "donation_count_label": {
          "one": "Donation",
          "other": "Donations"
        },
        "goto_description_link": "What’s it about?",
        "share_link": "Tell your friends",
        "target_amount_label": "Our goal"
      },
      "page_title_part": "Support my fundraising event",
      "sharing": {
        "copy_alert": {
          "headline": "Copied link!",
          "text": " You can add the link to your bio or story in Instagram."
        },
        "default_teaser": "Please support this project on betterplace",
        "email_share_label": "Recommend this fundraising event via email!",
        "email_teaser": "I found a great fundraising event on betterplace.org",
        "facebook_share_label": "Share this fundraising event on Facebook!",
        "headline": "Do you like this fundraising event? Then start helping!",
        "instagram_share_label": "Copy the link to this fundraising event for Instagram!",
        "link_share_label": "Copy the link to this fundraising event!",
        "messenger_share_label": "Share this fundraising event on Facebook Messenger!",
        "share_call_to_action": "And tell your friends.",
        "twitter_share_label": "Tweet this fundraising event!",
        "twitter_share_text": "Support the fundraising event %{name}",
        "whatsapp_share_label": "Share this fundraising event on Whatsapp!"
      }
    }
  },
  "misc": {
    "donate_button": "Donate now!",
    "state_labels": {
      "activated": "Active",
      "active": "Active",
      "awarded": "Awarded",
      "blocked": "Deactivated",
      "canceled": "Canceled",
      "closed": "Closed",
      "completed": "Funded",
      "confirmed": "Confirmed",
      "created": "Created",
      "deleted": "Deleted",
      "finished": "Finished",
      "inactive": "Inactive",
      "new": "New",
      "paid_out": "Paid out",
      "pending": "Pending",
      "preparing": "Preparing",
      "produced": "Produced",
      "proposed": "Proposed",
      "rejected": "Rejected",
      "requested": "Requested",
      "revoked": "Revoked",
      "started": "Started",
      "submitted": "Submitted"
    }
  },
  "news": {
    "news_helper": {
      "blog_details_html": "%{author} wrote on %{created_at}"
    },
    "no_results": {
      "call_to_action_html": "<a href='%{message_url}'>Why not ask %{manager_name}</a> if there’s any news to report.",
      "notice": "No news has been posted yet."
    }
  }
});
